import React from 'react';
import { Firebase } from './firebase';

export const FirebaseContext = React.createContext<Firebase | null>(null);

export function useFirebase() {
  const firebase = React.useContext(FirebaseContext);
  if (!firebase) {
    throw new Error('useFirebase must be used within FirebaseContext.Provider');
  }
  return firebase;
}